import {
  FETCH_TERMINAL_LOGS_LOADING,
  FETCH_TERMINAL_LOGS_SUCCESS,
  FETCH_TERMINAL_LOGS_FAILED,
  CLEAR_TERMINAL_LOGS
} from "../../actionTypeConstants/ml2.0/TerminalLogs";
import get from "lodash/get";

const initialState = {
  data: null,
  loading: true,
  url: "",
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TERMINAL_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        data: null,
        error: null
      };
    }

    case FETCH_TERMINAL_LOGS_SUCCESS: {
      const areLogsFetchedFromLTMA = get(
        action,
        ["payload", "areLogsFetchedFromLTMA"],
        false
      );
      const url = get(action, ["result", "config", "url"], "");

      const terminalLogs = get(action, ["result", "data"], "");
      const logList = areLogsFetchedFromLTMA
        ? typeof terminalLogs === "object"
          ? JSON.stringify(terminalLogs, undefined, 2)
          : terminalLogs
        : get(action, ["result", "data", "data"], "");
      return {
        ...state,
        url,
        loading: false,
        data: logList,
        error: null
      };
    }

    case FETCH_TERMINAL_LOGS_FAILED: {
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error.response
      };
    }

    case CLEAR_TERMINAL_LOGS: {
      return {
        ...state,
        loading: false,
        data: null,
        error: null
      };
    }

    default: {
      return state;
    }
  }
}
